up.migrate.renamedPackage('bus', 'event');
up.event.nobodyPrevents = function (...args) {
    up.migrate.deprecated('up.event.nobodyPrevents(type)', '!up.emit(type).defaultPrevented');
    const event = up.emit(...args);
    return !event.defaultPrevented;
};
up.$on = function (...definitionArgs) {
    up.migrate.warn('up.$on() has been deprecated. Instead use up.on() with a callback that wraps the given native element in a jQuery collection.');
    let callback = definitionArgs.pop();
    callback.upNativeCallback = function (event, element, data) {
        let $element = jQuery(element);
        callback.call($element, event, $element, data);
    };
    return up.on(...definitionArgs, callback.upNativeCallback);
};
up.$off = function (...definitionArgs) {
    up.migrate.deprecated('up.$off()', 'up.off()');
    let $callback = definitionArgs.pop();
    let nativeCallback = $callback.upNativeCallback;
    if (!nativeCallback) {
        up.fail('The callback passed to up.$off() was never registered with up.$on()');
    }
    return up.off(...definitionArgs, nativeCallback);
};
